/* eslint-disable */

import { useEffect, useState, useMemo } from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { Typography, useTheme } from '@mui/material';

import api from '../../services/api';
import { toast } from 'react-toastify';
import { getStyled } from './styles';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  Filler,
);

export const ChatsUser = ({ dateFrom, dateTo, finalizadas, canceladas }) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [ticketsData, setTicketsData] = useState([]);
  const [gradients, setGradients] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await api.get(
          `/dashboard/ticketsUsers?initialDate=${dateFrom}&finalDate=${dateTo}`,
        );

        const response = data.data.map((item) => {
          let quantidade;
          if (finalizadas && !canceladas) quantidade = Number(item.finalizadas);
          if (!finalizadas && canceladas) quantidade = Number(item.canceladas);
          if (finalizadas && canceladas)
            quantidade = Number(item.canceladas) + Number(item.finalizadas);
          return { ...item, quantidade: quantidade };
        });

        const list = response.sort((a, b) => {
          const quantidadeA = Number(a.quantidade);
          const quantidadeB = Number(b.quantidade);
          return quantidadeB - quantidadeA;
        });

        setTicketsData(list);
      } catch (error) {
        toastError('Erro ao obter informações da conversa', error.message);
      }
    };

    fetchData();
  }, [dateFrom, dateTo, canceladas, finalizadas]);

  const processedTicketsData = useMemo(() => {
    if (!ticketsData.length) return [];

    let list;

    if (finalizadas && !canceladas) {
      list = ticketsData.map((item) => {
        return { ...item, quantidade: Number(item.finalizadas) };
      });
    } else if (!finalizadas && canceladas) {
      list = ticketsData.map((item) => {
        return { ...item, quantidade: Number(item.canceladas) };
      });
    } else if (finalizadas && canceladas) {
      list = ticketsData.map((item) => {
        return {
          ...item,
          quantidade: Number(item.finalizadas) + Number(item.canceladas),
        };
      });
    } else {
      list = ticketsData;
    }

    return list;
  }, [ticketsData, finalizadas, canceladas]);

  useEffect(() => {
    if (!processedTicketsData.length) return;

    const canvas = document.createElement('canvas');
    canvas.width = 1;
    canvas.height = 300;
    const ctx = canvas.getContext('2d');

    if (!ctx) return;

    const chartGradients = [];
    processedTicketsData.forEach(() => {
      const gradient = ctx.createLinearGradient(0, 0, 0, 300);
      gradient.addColorStop(
        1,
        theme.palette.mode === 'light' ? theme.palette.primary.main : '#1D9FF0',
      );
      gradient.addColorStop(
        0,
        theme.palette.mode === 'light' ? theme.palette.primary.dark : '#1471AA',
      );
      chartGradients.push(gradient);
    });

    setGradients(chartGradients);
  }, [processedTicketsData, theme.palette.mode]);

  const filteredData =
    processedTicketsData.filter((item) => Number(item.quantidade) > 0) || [];

  const dataCharts = {
    labels: filteredData.map((item) => item.nome),
    datasets: [
      {
        data: filteredData.map((item) => Number(item.quantidade)),
        backgroundColor: gradients.slice(0, filteredData.length),
      },
    ],
  };

  return (
    <>
      <div style={classes.header}>
        <Typography
          component='h2'
          variant='h6'
          sx={{
            color:
              theme.palette.mode === 'dark'
                ? '#FFF'
                : theme.palette.primary.main,
          }}
          gutterBottom
        >
          Total de Atendimentos por Usuários
        </Typography>
      </div>

      <Bar
        options={classes.chartsUserOptions}
        data={dataCharts}
        style={{ maxWidth: '100%', maxHeight: '280px' }}
      />
    </>
  );
};
